
import React, { PureComponent } from "react";

import { IconTable, ClanRole, Table, TableBody, TableBodyCell, TableHead, TableHeadCell, TableRow, Button, ButtonGroup, Currency, Message, DivTooltip, TooltipBody } from "@wg/wows-react-uikit";

import map from "lodash/map";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import maxBy from "lodash/maxBy";
import filter from "lodash/filter";

import { thousands } from "../../../../../helpers/formatting";
import { t } from "../../../../../helpers/localization";
import { isoToFormattedLocalDateTime } from "../../../../../helpers/datetime";

import styles from "./PlayersRatingTable.scss";
import { IBattle } from "../../../../../Reducers/ReducerClanWars";

const PLAYERS_RATING_TABLE_HEAD_DATA = [{
  modify: 'small',
  type: 'role',
  tooltipBody: t('Должность')
}, {
  modify: 'basis',
  type: 'nickname',
  text: t('Игрок')

}, {
  modify: 'center',
  type: 'result',
  text: t('Результат'),
  tooltipBody: t('Количество взятых планок')

}, {
  modify: 'right',
  type: 'claimedGrade',
  text: t('Лучшая планка'),
  tooltipBody: t('Наивысшая взятая планка')
}, {
  modify: 'right',
  type: 'attempts',
  text: t('Попытки'),
  tooltipBody: t('Количество использованных попыток взятия планки')
}, {
  modify: 'right',
  type: 'finishedAt',
  text: t('Дата боя'),
  tooltipBody: t('Дата последнего боя с попыткой взятия планки')
}];

type Props = {
  maxPersonalAttempts: number;
  battles: Array<IBattle>;
  allPlayersInRatingTable: boolean;
  togglePlayersCountInRating?: () => void;
  onClick?: (spaId: any) => void;
};

const SHORT_HISTORY_MEMBERS_COUNT = 5;

class PlayersRatingTable extends PureComponent<Props> {

  renderTableHead() {
    return map(PLAYERS_RATING_TABLE_HEAD_DATA, (cell, key) => {
      return <TableHeadCell key={`head-cell-${key}`} modify={cell.modify}>
                    {cell.tooltipBody ? <DivTooltip tooltipBody={<TooltipBody>
                                    {cell.tooltipBody}
                                </TooltipBody>}>
                            {cell.type === 'role' ? <IconTable glyph="roles" /> : cell.text}
                        </DivTooltip> : cell.type === 'role' ? <IconTable glyph="roles" /> : cell.text}
                </TableHeadCell>;

    });
  }

  renderTableBody(playersArray: Array<any>) {
    return map(playersArray, (row, index) => {
      if (!this.props.allPlayersInRatingTable && index >= SHORT_HISTORY_MEMBERS_COUNT) return false;
      return <TableRow isHovering key={`war-table-row-${index}`} onClick={() => {
        if (this.props.onClick) {
          this.props.onClick(row.spaId);
        }
      }}>
                    <TableBodyCell modify="small" isHovering={false} onClick={() => {}}>
                        <ClanRole role={row.accountRole} />
                    </TableBodyCell>
                    <TableBodyCell modify="basis" isHovering={false} onClick={() => {}}>
                        <div>
                            {row.nick}
                        </div>
                    </TableBodyCell>
                    <TableBodyCell modify="center" isHovering={false} onClick={() => {}}>
                        {!row.isReachedGrade ? '—' : <Currency type="cwars-star" amount={row.reachedBattlesCount} t={t} />}
                    </TableBodyCell>
                    <TableBodyCell modify="right" isHovering={false} onClick={() => {}}>
                        {thousands(row.claimedGrade)}
                    </TableBodyCell>
                    <TableBodyCell modify="right" isHovering={false} onClick={() => {}}>
                        {row.attempts}/{this.props.maxPersonalAttempts}
                    </TableBodyCell>
                    <TableBodyCell modify="right" isHovering={false} onClick={() => {}}>
                        {isoToFormattedLocalDateTime(row.finishedAt.finishedAt ? row.finishedAt.finishedAt : row.finishedAt)}
                    </TableBodyCell>
                </TableRow>;
    });
  }

  render() {
    const players = {};

    forEach(this.props.battles, battle => {
      if (!players[battle.spaId]) players[battle.spaId] = [];

      players[battle.spaId].push(battle);
    });

    let playersArray = map(players, (playerBattles, key) => {

      let reachedBattles = filter(playerBattles, battle => {
        return battle.isReachedGrade;
      });

      const reachedBattlesCount = reachedBattles.length;
      let attempts = playerBattles.filter(battle => {
        return !!battle.finishedAt;
      }).length;

      if (attempts > this.props.maxPersonalAttempts) {
        attempts = this.props.maxPersonalAttempts;
      }

      if (playerBattles.length === 1 && playerBattles[0].attempts) {
        attempts = playerBattles[0].attempts;
      }

      const maxGradeBattle = reachedBattlesCount ? maxBy(reachedBattles, battle => {
        return battle.claimedGrade;
      }) : playerBattles[playerBattles.length - 1];

      return {
        ...maxGradeBattle,
        reachedBattlesCount,
        attempts,
        finishedAt: playerBattles[playerBattles.length - 1]
      };
    });

    playersArray.sort((a, b) => {
      if (b.reachedBattlesCount === a.reachedBattlesCount) return b.claimedGrade - a.claimedGrade;


      return b.reachedBattlesCount - a.reachedBattlesCount;
    });

    return !isEmpty(playersArray) ? <div>
                    <Table>
                        <TableHead>
                            {this.renderTableHead()}
                        </TableHead>
                        <TableBody>
                            {this.renderTableBody(playersArray)}
                        </TableBody>
                    </Table>
                    {playersArray.length > SHORT_HISTORY_MEMBERS_COUNT ? <div className={styles.palyerRatingFooter}>
                                    <ButtonGroup>
                                        <Button onClick={this.props.togglePlayersCountInRating ? this.props.togglePlayersCountInRating : () => {}}>
                                            {this.props.allPlayersInRatingTable ? t('Закрыть полный список') : t('Открыть полный список')}
                                        </Button>
                                    </ButtonGroup>
                                </div> : null}
                </div> : <Message style="fullsize" type="info">
                    {t('Игроки вашего клана еще не участовали в битве')}
                </Message>;
  }
}

export default PlayersRatingTable;